import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosNoSession } from "../../config/axiosAuth";
import sha256 from "sha256";
import Header from "../../common/Header";
import { Box, IconButton } from "@mui/material";
import OtpInput from "react18-input-otp";
import style from "./setPassword.module.css";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { userSetPassword } from "../../services/authServices";
import { IoMdClose, IoMdCloseCircleOutline } from "react-icons/io";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function SetPassword() {
  const [isReEnterOTP, setIsReEnterOTP] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [enterOTP, setEnterOTP] = useState("");
  const [reEnterOTP, setReEnterOTP] = useState("");
  const [isWrongPsscode, setIsWrongPsscode] = useState(false);

  const navigate = useNavigate();

  const verification_token = localStorage.getItem("verification_token");
  const user_id = localStorage.getItem("userId");

  // useMemo(() => {
  //   if (reEnterOTP?.length == 6) {
  //     if (enterOTP == reEnterOTP) {
  //       handleSubmitReEnterOtp();
  //     } else {
  //       setIsWrongPsscode(true);
  //       localStorage.setItem("login", JSON.stringify(false));
  //     }
  //   }
  // }, [reEnterOTP]);

  React.useEffect(() => {
    if (isWrongPsscode) {
      const timer = setTimeout(() => {
        setIsWrongPsscode(false);
      }, 3000); // auto-close after 3s

      return () => clearTimeout(timer);
    }
  }, [isWrongPsscode]);

  const handleChangeOtp = (otp) => {
    setEnterOTP(otp);
    if (reEnterOTP) {
      setReEnterOTP("");
    }
    if (otp?.length === 6) {
      setIsReEnterOTP(true);
    }
    if (otp?.length !== 6 && isReEnterOTP) {
      setIsReEnterOTP(false);
    }
  };

  const handleSubmitOTP = () => {
    setIsReEnterOTP(true);
  };

  const handleChangeReEnterOtp = (otp, e) => {
    setReEnterOTP(otp);

    if (otp?.length == 6) {
      if (enterOTP == otp) {
        handleSubmitReEnterOtp();
      } else {
        setIsWrongPsscode(true);
        localStorage.setItem("login", JSON.stringify(false));
      }
    }
  };

  function handleSubmitReEnterOtp() {
    callSetPasscodeAPI(enterOTP);
    localStorage.setItem("login", JSON.stringify(true));
  }

  async function callSetPasscodeAPI(data) {
    try {
      const Obj = {
        secret_access_key: sha256(data),
        verification_token,
      };
      const request = await userSetPassword(user_id, Obj);
      const response = await request.data;
      if (response.status == 1) {
        localStorage.setItem("session_id", response?.data?.session_id);
        navigate("/success-registration");
        setIsSuccessModal(true);
        setIsReEnterOTP(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      {/* <Snackbar
        open={isWrongPsscode}
        autoHideDuration={3000}
        onClose={() => setIsWrongPsscode((prev) => !prev)}
        style={{
          position: "absolute",
          // bottom: "10%",
        }}
      >
        <Alert
          onClose={() => setIsWrongPsscode((prev) => !prev)}
          sx={{
            width: "100%",
            backgroundColor: "white",
            postMessage: "fixed",
            // marginBottom: "10%",
            color: "black",
            textAlign: "center",
          }}
        >
          invalid passcode entered, please enter the correct passcode
        </Alert>
      </Snackbar> */}
      <Header header="Set New Passcode" />
      <Box
        style={{
          width: "100vw",
          position: "fixed",
          zIndex: "-1",
        }}
      >
        <img
          src={process.env.PUBLIC_URL + "/assets/images/new_otp_background.jpg"}
          height={"100%"}
          width="100%"
          alt="background"
          style={{
            height: "100svh",
            width: "100svw",
            objectFit: "cover",
          }}
        />
      </Box>
      <Box
        sx={{
          width: "100svw",
          height: "100svh",
          margin: "1rem 0rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1.5rem",
          overflow: "auto",
          position: "fixed",
        }}
      >
        <h4 className={style.otp_description}>
          {!isReEnterOTP ? (
            <div className={style.newPasscodeTitle}>
              <h1>Set your Secret Access Code</h1>
              <p>
                Keep your passcode safe. It secures your sensitive information.
                Memorize your passcode.
                <br />
                We do not store it with us.
              </p>
            </div>
          ) : (
            <div className={style.newPasscodeTitle}>
              <h1>Re-enter your Secret Access Code</h1>
            </div>
          )}
        </h4>
        {!isSuccessModal && (
          <>
            <OtpInput
              value={enterOTP}
              onChange={handleChangeOtp}
              numInputs={6}
              isInputNum={true}
              isSuccessed={false}
              errorStyle="error"
              successStyle="success"
              shouldAutoFocus
              isInputSecure
              inputProps={{
                type: "password",
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              onSubmit={handleSubmitOTP}
              inputStyle={{
                width: "100%",
                maxWidth: "50px",
                marginLeft: "0.5rem",
                height: "4.6875rem",
                border: "1px solid transparent",
                borderRadius: "8px",
                fontSize: "25px",
                // fontSize: " 1.0625",
                color: "#000",
                fontWeight: "400",
                caretColor: "blue",
                caretColor: "black",
                outline: "none",
              }}
              focusStyle={{
                border: "2px solid black",
              }}
            />
            {isReEnterOTP && (
              <>
                <OtpInput
                  value={reEnterOTP}
                  onChange={handleChangeReEnterOtp}
                  numInputs={6}
                  isInputNum={true}
                  isSuccessed={false}
                  errorStyle="error"
                  successStyle="success"
                  isInputSecure
                  inputProps={{
                    type: "password",
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  shouldAutoFocus
                  onSubmit={handleSubmitOTP}
                  inputStyle={{
                    width: "100%",
                    maxWidth: "50px",
                    marginLeft: "0.5rem",
                    height: "4.6875rem",
                    border: "1px solid  #C2C2C2",
                    color: "white",
                    borderRadius: "8px",
                    fontSize: "25px",
                    // fontSize: " 1.0625",
                    fontWeight: "400",
                    caretColor: "blue",
                    backgroundColor: "rgba(240, 120, 33, 0.25)",
                    caretColor: "black",
                    outline: "none",
                  }}
                  focusStyle={{
                    border: "2px solid black",
                  }}
                />
                {isWrongPsscode && (
                  <div style={{ padding: "0 15px" }}>
                    <Alert
                      severity="error"
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        mt: 1,
                        width: "100%",
                        maxWidth: "400px",
                        justifyContent: "space-between",
                      }}
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => setIsWrongPsscode(false)}
                        >
                          <IoMdClose fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Invalid passcode entered, please try again.
                    </Alert>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </Box>
    </>
  );
}
